export default "__VITE_PUBLIC_ASSET__7c7c8c2f__"